import LabelOptionRenderer from 'app/components/labels/LabelOptionRenderer';
import { SynthFilterDef, SynthFilterId } from './types';

/**
 * Registry of synth filter definitions. Each entry decouples option derivation and
 * state binding from layout so any tab can render an ordered subset (see tabFilterConfig).
 */
export const synthFilterDefs: Record<SynthFilterId, SynthFilterDef> = {
  sourceAgent: {
    id: 'sourceAgent',
    renderer: 'agentSelect',
    label: () => 'Source Agent',
    placeholder: () => 'All Agents',
    getOptions: (ctx) => ctx.agentOptions,
    getValues: (state) => state.sharedFilterAgentIds.map(String),
    setValues: (state, values) => state.setSharedFilterAgentIds(values.map(Number)),
    isAvailable: () => true,
    showSelectAll: true,
    field: { minWidth: 220, flex: '1 1 220px', maxWidth: 320 }
  },

  target: {
    id: 'target',
    renderer: 'select',
    label: (test) => (test.isDns ? 'Resolver' : 'Target'),
    placeholder: (test) => (test.isDns ? 'All Resolvers' : 'All Targets'),
    getOptions: (ctx) => ctx.targetOptions,
    getValues: (state) => state.sharedFilterTargets,
    setValues: (state, values) => state.setSharedFilterTargets(values),
    // Only useful when there's more than one target to choose from.
    isAvailable: (ctx) => ctx.targetOptions.length > 1,
    showSelectAll: true,
    menuWidth: 320,
    field: { minWidth: 170, flex: '1 1 180px', maxWidth: 320 }
  },

  site: {
    id: 'site',
    renderer: 'select',
    label: () => 'Agent Site',
    placeholder: () => 'All Sites',
    getOptions: (ctx) => ctx.siteOptions,
    getValues: (state) => state.sharedFilterSiteIds,
    setValues: (state, values) => state.setSharedFilterSiteIds(values),
    isAvailable: () => true,
    disabledWhenEmpty: true,
    menuWidth: 260,
    field: { minWidth: 170, flex: '1 1 180px', maxWidth: 260 }
  },

  asn: {
    id: 'asn',
    renderer: 'select',
    label: () => 'Agent ASN',
    placeholder: () => 'All ASNs',
    getOptions: (ctx) => ctx.asnOptions,
    getValues: (state) => state.sharedFilterAsns,
    setValues: (state, values) => state.setSharedFilterAsns(values),
    isAvailable: (ctx) => ctx.asnOptions.length > 0,
    menuWidth: 280,
    field: { minWidth: 170, flex: '1 1 180px', maxWidth: 260 }
  },

  label: {
    id: 'label',
    renderer: 'select',
    label: () => 'Agent Label',
    placeholder: () => 'All Labels',
    getOptions: (ctx) => ctx.labelOptions,
    getValues: (state) => state.sharedFilterLabelIds,
    setValues: (state, values) => state.setSharedFilterLabelIds(values),
    isAvailable: (ctx) => ctx.labelOptions.length > 0,
    optionFormatter: LabelOptionRenderer,
    menuWidth: 260,
    field: { minWidth: 170, flex: '1 1 180px', maxWidth: 260 }
  }
};
